/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumMessageTemplateLanguage = "am" | "ar" | "bn" | "cn" | "de" | "en" | "es" | "fa" | "fl" | "fr" | "gr" | "gu" | "hi" | "ht" | "hy" | "it" | "ja" | "km" | "ko" | "mr" | "my" | "pa" | "pl" | "pt" | "ru" | "so" | "th" | "ti" | "tl" | "uk" | "ur" | "vi" | "zh" | "zhS" | "zhT" | "%future added value";
export type DialogMessageTemplateAuditRestore_MessageTemplate = {
    readonly key: string | null;
    readonly language: EnumMessageTemplateLanguage | null;
    readonly " $refType": "DialogMessageTemplateAuditRestore_MessageTemplate";
};
export type DialogMessageTemplateAuditRestore_MessageTemplate$data = DialogMessageTemplateAuditRestore_MessageTemplate;
export type DialogMessageTemplateAuditRestore_MessageTemplate$key = {
    readonly " $data"?: DialogMessageTemplateAuditRestore_MessageTemplate$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DialogMessageTemplateAuditRestore_MessageTemplate">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DialogMessageTemplateAuditRestore_MessageTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    }
  ],
  "type": "MessageTemplate",
  "abstractKey": null
};
(node as any).hash = '0510f20a500427deedcd88ddaf1054c8';
export default node;
